import React, { JSX } from 'react';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Link,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

export function RegistrationTypeSelector(): JSX.Element {
  const navigate = useNavigate();

  return (
    <Paper elevation={3}>
      <Box sx={{ p: 5 }}>
        <Box sx={{ textAlign: 'center', mb: 5 }}>
          <Typography variant="h3" component="h1" sx={{ mb: 2 }}>
            Join Backstory
          </Typography>
          <Typography variant="h6" color="text.secondary">
            Choose how you&apos;d like to get started
          </Typography>
        </Box>
        <Stack direction="row" spacing={3}>
          <RegistrationCard
            icon="👤"
            title="I'm looking for work"
            description="Create a candidate profile to find your next opportunity"
            buttonLabel="Join as Candidate"
            onClick={() => navigate('/register/candidate')}
          />
          <RegistrationCard
            icon="🏢"
            title="I'm hiring"
            description="Create a company account to find and hire talent"
            buttonLabel="Join as Employer"
            onClick={() => navigate('/register/employer')}
          />
        </Stack>
        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography variant="body2" color="text.secondary">
            Already have an account?{' '}
            <Link href="/login" sx={{ fontWeight: 600 }}>
              Sign in here
            </Link>
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}

function RegistrationCard(props: {
  icon: string;
  title: string;
  description: string;
  buttonLabel: string;
  onClick: () => void;
}): JSX.Element {
  return (
    <Card
      sx={{
        flex: 1,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        border: '2px solid transparent',
        '&:hover': { transform: 'translateY(-4px)', boxShadow: 6, borderColor: 'primary.main' },
      }}
      onClick={props.onClick}
    >
      <CardContent sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="h1" sx={{ mb: 2 }}>
          {props.icon}
        </Typography>
        <Typography variant="h5" component="h3" sx={{ mb: 1.5 }}>
          {props.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {props.description}
        </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button variant="contained" size="large">
          {props.buttonLabel}
        </Button>
      </CardActions>
    </Card>
  );
}
